import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { shipmentEndpoint } from '../../../../utils/constants/requestUrl';

@Injectable({
  providedIn: 'root',
})
export class ShipmentUploadService {
  constructor(private httpClient: HttpClient) {}

  shipmentUploadFileStatus(fromDate: string, toDate: string): Observable<unknown> {
    const requestBody = {
      dateRange: {
        dateField: 'upload_datetime',
        fromDate,
        toDate,
      },
    };
    return this.httpClient.post(
      `${environment.shipmentUrl}${shipmentEndpoint.fileUploadStatus}`,
      requestBody
    );
  }
}
